import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MarketInsightCard = ({ insight }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isShared, setIsShared] = useState(false);

  const handleShare = () => {
    setIsShared(true);
    setTimeout(() => setIsShared(false), 2000);
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'regulatory': return 'bg-warning/10 text-warning border-warning/20';
      case 'market': return 'bg-cta/10 text-cta border-cta/20';
      case 'talent': return 'bg-success/10 text-success border-success/20';
      default: return 'bg-muted text-muted-foreground border-border';
    }
  };

  return (
    <div className="card-elevated p-6 hover:shadow-executive-hover transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 gradient-executive rounded-lg flex items-center justify-center">
            <Icon name={insight.icon} size={24} color="white" />
          </div>
          <div>
            <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getCategoryColor(insight.category)}`}>
              {insight.category.charAt(0).toUpperCase() + insight.category.slice(1)}
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleShare}
            iconName={isShared ? "Check" : "Share2"}
            iconSize={16}
          >
            {isShared ? 'Shared' : 'Share'}
          </Button>
        </div>
      </div>

      <h3 className="font-headline font-semibold text-lg text-text-primary mb-2">
        {insight.title}
      </h3>

      <p className="text-text-secondary mb-4">
        {isExpanded ? insight.fullContent : insight.summary}
      </p>

      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4 text-sm text-text-secondary">
          <div className="flex items-center space-x-1">
            <Icon name="User" size={14} />
            <span>{insight.author}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span>{insight.date}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={14} />
            <span>{insight.readTime} min read</span>
          </div>
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
        >
          {isExpanded ? 'Show Less' : 'Read More'}
        </Button>
      </div>

      {insight.tags && (
        <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-border">
          {insight.tags.map((tag, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted text-text-secondary text-xs rounded-md"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default MarketInsightCard;